import React, { useState, useEffect } from "react";
import axiosInstance from "../../../axios/axiosInstance";
import FamilyTree from "./family/FamilyTree";

interface FamilyDetailsTabProps {
  memberId: number;
  memberData: any;
  onRefresh: () => void;
}

export default function FamilyDetailsTab({ memberId, memberData, onRefresh }: FamilyDetailsTabProps) {
  const [familyData, setFamilyData] = useState<any>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchFamilyData();
  }, [memberId]);

  const fetchFamilyData = async () => {
    setLoading(true);
    try {
      const resp: any = await axiosInstance.get(`/api/members/${memberId}/family`);
      if (resp?.status === 200) {
        setFamilyData(resp.data?.data);
      }
    } catch (error: any) {
      // Family data might not exist yet, that's okay
      setFamilyData(null);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center py-12">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      {/* Family information only - add options hidden */}
      <div className="bg-white dark:bg-gray-800 rounded-xl shadow-lg border border-gray-200 dark:border-gray-700 p-4">
        <h2 className="text-lg font-bold text-gray-900 dark:text-white flex items-center gap-2">
          <i className="fa-solid fa-users text-blue-600 dark:text-blue-400"></i>
          Family Relationships
        </h2>
      </div>

      {/* Family Tree Display */}
      {familyData ? (
        <div className="bg-white dark:bg-gray-800 rounded-xl shadow-lg border border-gray-200 dark:border-gray-700 p-6">
          <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-6 flex items-center gap-2">
            <i className="fa-solid fa-sitemap text-blue-600 dark:text-blue-400"></i>
            Family Tree
          </h3>
          <FamilyTree familyData={familyData} />
        </div>
      ) : (
        <div className="bg-white dark:bg-gray-800 rounded-xl shadow-lg border border-gray-200 dark:border-gray-700 p-6 text-center">
          <div className="text-gray-500 dark:text-gray-400 py-8">
            No family members added yet.
          </div>
        </div>
      )}

    </div>
  );
}

